import React, { forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '../Typography';
import './CheckboxInput.css';

export const CheckboxInput = forwardRef(({
  onChange,
  displayLabel,
  name,
  wrapperClassName,
  labelClassName,
  inputClassName,
}, ref) => {
  const unusedRef = useRef();
  const inputRef = ref || unusedRef;

  return (
    <div className={wrapperClassName}>
      <label htmlFor={name} className={labelClassName}>
        <input
          ref={inputRef}
          data-testid="testid-CheckboxInput"
          onChange={onChange}
          className={inputClassName}
          type="checkbox"
          name={name}
          id={name}
        />
        <Typography>{displayLabel}</Typography>
      </label>
    </div>
  );
});

CheckboxInput.propTypes = {
  onChange: PropTypes.func,
  displayLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
};

CheckboxInput.defaultProps = {
  onChange: () => { },
  wrapperClassName: 'checkbox-input-wrapper',
  labelClassName: 'checkbox-label',
  inputClassName: 'checkbox-input',
};
